import React from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import styled from "styled-components";

const StyledDataPointIcon = styled.span`
  position: absolute;
  left: -12px;
  top: 7px;
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 3px solid ${({ color }) => color};
`;
const StyledChartWrapper = styled.div`
  width: 420px;
  svg {
    overflow: visible;
  }
`;
const StyledDataPointLink = styled.div`
  cursor: pointer;
  font-size: 12px;
  position: relative;
  color: #6d777d;
`;
const StyledDataPointValue = styled.div`
  font-weight: 600;
  margin-bottom: 24px;
`;
// Make reusable
function DonutChart({ title, info }) {
  // Pending backend
  const toggle = (seriesIndex) => {
    ApexCharts.exec("totalreservationsdonutchart", "toggleDataPointSelection", [seriesIndex]);
  };
  const config = {
    colors: ["#00CCD2", "#FF870E", "#CB0000", "#0d80ff"],
    series: info,
    labels: [
      "Reservas concluídas com compra",
      "Reservas pendentes",
      "Reservas canceladas",
      "Usuário reservo mas não compareceu",
    ],
  };

  const options = {
    series: config.series,

    options: {
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                showAlways: true,
                label: "Reservas totais",
                fontSize: "15px",
                fontFamily: "Univa Nova, sans-serif",
                fontWeight: 500,
                color: "#6D777D",
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                },
              },
            },
          },
          customScale: 1,
        },
      },
      labels: config.labels,
      legend: {
        show: false,
        position: "bottom",
        horizontalAlign: "center",
      },
      chart: {
        id: "totalreservationsdonutchart",
        type: "donut",
        width: "100%",
        height: "100%",
      },
      colors: config.colors,
    },
  };

  return (
    <div className="card border-0 shadow-sm px-4 ps-0 donut-chart h-100 px-0" style={{ borderRadius: 10 }}>
      <div className="card-header bg-white border-0">
        <span className="text-cl-indigo ff-univanova-600 fz-18">{title}</span>
      </div>
      <div className="row card-body px-2 py-2 d-flex justify-content-around align-items-center">
        <StyledChartWrapper className="col-12 col-lg-8">
          <Chart options={options.options} series={options.series} type="donut" />
        </StyledChartWrapper>
        <div className="col-12 col-lg-4">
          <StyledDataPointLink onClick={() => toggle(0)}>
            <StyledDataPointIcon color={config.colors[0]} />
            {config.labels[0]}
          </StyledDataPointLink>
          <StyledDataPointValue className="col-12">{config.series[0]}</StyledDataPointValue>
          <StyledDataPointLink onClick={() => toggle(1)}>
            <StyledDataPointIcon color={config.colors[1]} />
            {config.labels[1]}
          </StyledDataPointLink>
          <StyledDataPointValue className="col-12">{config.series[1]}</StyledDataPointValue>
          <StyledDataPointLink onClick={() => toggle(2)}>
            <StyledDataPointIcon color={config.colors[2]} />
            {config.labels[2]}
          </StyledDataPointLink>
          <StyledDataPointValue className="col-12">{config.series[2]}</StyledDataPointValue>
          {/* <StyledDataPointLink onClick={() => toggle(3)}>
            <StyledDataPointIcon color={config.colors[3]} />
            {config.labels[3]}
          </StyledDataPointLink> */}
          <StyledDataPointValue className="col-12">{config.series[3]}</StyledDataPointValue>
        </div>
      </div>
    </div>
  );
}

export default DonutChart;
